import React from 'react'
import { useIntl } from 'react-intl'

import LineUsersMultiIcon from 'LuxKit/Icons/line/LineUsersMultiIcon'
import LineTachometerFastIcon from 'LuxKit/Icons/line/LineTachometerFastIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineArrowGrowthIcon from 'LuxKit/Icons/line/LineArrowGrowthIcon'
import LineLightbulbAltIcon from 'LuxKit/Icons/line/LineLightbulbAltIcon'
import LineMountainRoadIcon from 'LuxKit/Icons/line/LineMountainRoadIcon'

function useMissionAndValuesItems() {
  const intl = useIntl()

  return [
    {
      title: intl.formatMessage({
        id: 'FPqHDAxIKt',
        defaultMessage: 'Think like our customer',
        description: 'Mission value title for customer-centric thinking on careers page',
      }),
      text: [
        intl.formatMessage({
          id: 'Xnyg1mCXzz',
          defaultMessage: 'Understand what our customers',
          description: 'First point for customer-centric thinking value on careers page',
        }),
        intl.formatMessage({
          id: 'lyJIIJ9+lK',
          defaultMessage: 'Want (before they do)',
          description: 'Second point for customer-centric thinking value on careers page',
        }),
      ],
      icon: <LineUsersMultiIcon size={68} colour="primary" />,
    },
    {
      title: intl.formatMessage({
        id: 'sZcvzZ/Byf',
        defaultMessage: 'Act like a startup',
        description: 'Mission value title for startup mentality on careers page',
      }),
      text: [
        intl.formatMessage({
          id: 'caTeqhpT0Z',
          defaultMessage: 'Be agile, take risks, kill bureaucracy',
          description: 'First point for startup mentality value on careers page',
        }),
        intl.formatMessage({
          id: 'ow9iW17JF9',
          defaultMessage: 'Everyone can act like a founder',
          description: 'Second point for startup mentality value on careers page',
        }),
      ],
      icon: <LineTachometerFastIcon size={68} colour="primary" />,
    },
    {
      title: intl.formatMessage({
        id: 'PtP59q+tF0',
        defaultMessage: 'Extra effort is recognised and rewarded',
        description: 'Mission value title for recognition and reward on careers page',
      }),
      text: [
        intl.formatMessage({
          id: 'fyLxZ4zU3G',
          defaultMessage: 'Call out outstanding effort and achievement',
          description: 'First point for recognition value on careers page',
        }),
        intl.formatMessage({
          id: 'ZEiEhAlnTN',
          defaultMessage: 'Give praise',
          description: 'Second point for recognition value on careers page',
        }),
      ],
      icon: <LineStarIcon size={68} colour="primary" />,
    },
    {
      title: intl.formatMessage({
        id: '70+sMhTQ6H',
        defaultMessage: 'Help others succeed',
        description: 'Mission value title for helping others on careers page',
      }),
      text: [
        intl.formatMessage({
          id: 'xS9dY+kccn',
          defaultMessage: 'Helping someone else to succeed is the best form of success',
          description: 'Point for helping others value on careers page',
        }),
      ],
      icon: <LineArrowGrowthIcon size={68} colour="primary" />,
    },
    {
      title: intl.formatMessage({
        id: 'gKyv17pmBF',
        defaultMessage: 'Focus on the solution, learn from your mistakes',
        description: 'Mission value title for solution-focused learning on careers page',
      }),
      text: [
        intl.formatMessage({
          id: 'J4CKXqyYDr',
          defaultMessage: 'Don’t be afraid of making mistakes - just make sure to learn from them',
          description: 'First point for solution-focused learning value on careers page',
        }),
        intl.formatMessage({
          id: 'C2/TZfKBPy',
          defaultMessage: 'Understand the problem, but deliver the solution',
          description: 'Second point for solution-focused learning value on careers page',
        }),
      ],
      icon: <LineLightbulbAltIcon size={68} colour="primary" />,
    },
    {
      title: intl.formatMessage({
        id: 'dHTANOptyI',
        defaultMessage: 'Do the hard things',
        description: 'Mission value title for tackling hard challenges on careers page',
      }),
      text: [
        intl.formatMessage({
          id: 'Zn5EW4QXi4',
          defaultMessage: 'The best businesses are great at doing hard things',
          description: 'Point for tackling hard challenges value on careers page',
        }),
      ],
      icon: <LineMountainRoadIcon size={68} colour="primary" />,
    },
  ]
}

export default useMissionAndValuesItems
